<template>
  <div class="container">
    <h4 class="title is-4">Request</h4>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <router-link :to="{path: '/tools/requester'}">Requester</router-link>
              </li>
              <li>
                <router-link :to="{path: '/tools/requester/collections/' + collection.id}">{{displayedCollectionName}}
                </router-link>
              </li>
              <li class="is-active" aria-current="page">
                <span style="margin-left: 0.75rem;">
                  Request
                </span>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <div class="container has-text-left">
      <app-request :params="request" @save="handleSaveRequest"/>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import Request from '../components/tools/Request';

  export default {
    components: {
      appRequest: Request,
    },
    name: "screenrequest",
    props: ['id', 'collectionId'],
    data() {
      return {
        collectionInProps: false,
        request: null
      };
    },
    computed: {
      ...mapGetters('requester', ['collectionByRequestId', 'collectionById', 'requestById']),
      collection() {
        if (this.collectionInProps) {
          return this.collectionById(this.collectionId);
        }

        return this.collectionByRequestId();
      },
      displayedCollectionName() {
        if (this.collection) {
          return `${this.collection.name} Collection`;
        }

        return 'Default Collection';
      }
    },
    methods: {
      ...mapActions('requester', ['saveRequest']),
      handleSaveRequest(params) {
        params['collectionId'] = this.collection.id;
        this.saveRequest(params);
      }
    },
    created() {
      this.collectionInProps = this.collectionId > 0;
    },
    mounted() {
      if (this.id) {
        this.request = this.requestById(this.id);
        /* eslint-disable */
        console.log(this.request);
      }
    },
    unmounted() {
      this.collectionInProps = false;
    }
  }
</script>

<style scoped>

</style>